import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  purchaseOrders: [],
  basket: [],
  purchaseOrderConfig: [],
  sellerPurchaseOrders: [],
  buyerPurchaseOrders: [],
};

const purchaseOrdersSlice = createSlice({
  name: "purchaseOrders",
  initialState,
  reducers: {
    setPurchaseOrders(state, action) {
      state.purchaseOrders = action.payload;
    },
    setBuyerPurchaseOrders(state, action) {
      state.buyerPurchaseOrders = action.payload;
    },
    setSellerPurchaseOrders(state, action) {
      state.sellerPurchaseOrders = action.payload;
    },
    addPurchaseOrder(state, action) {
      const newPurchaseOrder = action.payload;
      state.purchaseOrders.push(newPurchaseOrder);
    },
    addToBasket(state, action) {
      const item = action.payload;
      const existing = state.basket.find(
        (p) =>
          p.catalogueSimProductId.catalogueId ===
            item.catalogueSimProductId.catalogueId &&
          p.catalogueSimProductId.simProductId ===
            item.catalogueSimProductId.simProductId
      );
      if (existing) {
        existing.quantity += item.quantity || 1;
      } else {
        state.basket.push({ ...item, quantity: item.quantity || 1 });
      }
    },
    removeFromBasket(state, action) {
      const id = action.payload;
      console.log(id, state.basket);
      state.basket = state.basket.filter(
        (item) =>
          item.catalogueSimProductId.catalogueId !== id.catalogueId &&
          item.catalogueSimProductId.simProductId !== id.simProductId
      );
    },
    updateBasketQuantity(state, action) {
      const { id, quantity } = action.payload;
      const item = state.basket.find(
        (p) =>
          p.catalogueSimProductId.catalogueId === id.catalogueId &&
          p.catalogueSimProductId.simProductId === id.simProductId
      );
      if (item && quantity > 0) {
        item.quantity = quantity;
      }
    },
    clearBasket(state) {
      state.basket = [];
    },
    setPurchaseOrderConfig(state, action) {
      state.purchaseOrderConfig = action.payload;
    },
    updatePurchaseOrder(state, action) {
      const { updatedOrder, category } = action.payload;
      let index = -1;
      if (category === "buying") {
        index = state.buyerPurchaseOrders.findIndex(
          (order) => order.id === updatedOrder.id
        );
        if (index !== -1) {
          state.buyerPurchaseOrders[index] = updatedOrder;
        }
      } else {
        index = state.sellerPurchaseOrders.findIndex(
          (order) => order.id === updatedOrder.id
        );
        if (index !== -1) {
          state.sellerPurchaseOrders[index] = updatedOrder;
        }
      }
    },
  },
});

export function getSellerPurchaseOrders() {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/purchase-order/seller`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        purchaseOrdersSlice.actions.setSellerPurchaseOrders(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      purchaseOrdersSlice.actions.setSellerPurchaseOrders([]);
      return Promise.reject(error.message);
    }
  };
}

export function getBuyerPurchaseOrder() {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/purchase-order/buyer`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        purchaseOrdersSlice.actions.setBuyerPurchaseOrders(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(purchaseOrdersSlice.actions.setBuyerPurchaseOrders([]));
      return Promise.reject(error.message);
    }
  };
}

export function createPurchaseOrder({ data }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/purchase-order`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        purchaseOrdersSlice.actions.addPurchaseOrder(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function storePurchaseOrder({ data }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/purchase-order`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        purchaseOrdersSlice.actions.addPurchaseOrder(response.data.data)
      );
      dispatch(purchaseOrdersSlice.actions.clearBasket());
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function updatePurchaseOrderStatus({ id, status, category }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/purchase-order/${id}/status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
          params: {
            status: status,
          },
        }
      );
      dispatch(
        purchaseOrdersSlice.actions.updatePurchaseOrder({
          updatedOrder: response.data.data,
          category: "selling",
        })
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export const {
  addToBasket,
  removeFromBasket,
  updateBasketQuantity,
  clearBasket,
} = purchaseOrdersSlice.actions;

export default purchaseOrdersSlice.reducer;
